import GenericModal from '../GenericModal/GenericModal';
import { Button } from '@mui/material';

interface IConfirmActionModalProps {
  prompt: string;
  modalOpen: boolean;
  onClose: () => void;
  confirmButtonOnClick: () => void;
  cancelButtonOnClick?: () => void;
}

const ConfirmActionModal: React.FC<IConfirmActionModalProps> = (props) => {
  return (
    <GenericModal
      open={props.modalOpen}
      onClose={props.onClose}
      title=""
      content={
        <div style={{ padding: '1.75rem', textAlign: 'center' }}>
          <div>
            <span>{props.prompt}</span>
          </div>
          <div style={{ paddingTop: '1rem' }}>
            <div style={{ paddingRight: '1rem', display: 'inline-block' }}>
              <Button
                size="small"
                onClick={props.confirmButtonOnClick}
                variant="contained"
                color="primary"
              >
                Confirm
              </Button>
            </div>
            <div style={{ display: 'inline-block' }}>
              <Button
                size="small"
                onClick={
                  props.cancelButtonOnClick
                    ? props.cancelButtonOnClick
                    : props.onClose
                }
                variant="contained"
                color="secondary"
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default ConfirmActionModal;
